import styles from './PlayIcon.module.css';

interface Props {
  className?: string;
  variant?: 'transparent' | 'solid';
}

export const PlayIcon = ({ className, variant = 'transparent' }: Props) => {
  switch (variant) {
    case 'transparent':
      return (
        <svg
          viewBox='0 0 24 24'
          xmlns='http://www.w3.org/2000/svg'
          className={`${styles.play_icon} ${styles.transparent} ${className}`}
        >
          <circle cx='12' cy='12' r='10' />
          <path d='M10.7 15.85L15.41 13.06C16.19 12.6 16.19 11.4 15.41 10.94L10.7 8.15C9.93 7.71 9 8.29 9 9.21v5.58c0 .92.93 1.5 1.7 1.06z' />
        </svg>
      );
    case 'solid':
      return (
        <svg
          viewBox='0 0 24 24'
          xmlns='http://www.w3.org/2000/svg'
          className={`${styles.play_icon} ${styles.solid} ${className}`}
        >
          <defs>
            {/* Black/White Mask for transparency*/}
            <mask id='playCutoutMask'>
              <circle cx='12' cy='12' r='10' fill='white' />
              <path
                d='M10.7 15.85L15.41 13.06C16.19 12.6 16.19 11.4 15.41 10.94L10.7 8.15C9.93 7.71 9 8.29 9 9.21v5.58c0 .92.93 1.5 1.7 1.06z'
                fill='black'
              />
            </mask>
          </defs>

          {/* Apply mask so the play shape is cut out from the circle */}
          <circle cx='12' cy='12' r='10' mask='url(#playCutoutMask)' />
        </svg>
      );
    default:
      return null;
  }
};
